import React from 'react'
import PropTypes from 'prop-types'
import Style from './styleSearch'
import UserBadge from './component'
import { COMPONENT_TEXT } from '../../helpers'

class UserBadgeSearch extends React.Component {
  renderBadge (user, index) {
    return (
      <UserBadge
        key={user.username}
        id={user.id}
        name={user.name}
        username={user.username}
        image={user.image}
        index={index}
        handleClick={() => {
          this.props.handleClick({
            id: user.id,
            username: user.username,
            name: user.name
          })
        }}
      />
    )
  }

  renderEmptyList () {
    const { language = 'EN' } = this.props
    return (
      <div className='list-search empty'>
        {COMPONENT_TEXT.NO_SEARCH[language]}
      </div>
    )
  }

  render () {
    const props = Object.assign({}, this.props)
    if (props.selectedOwner) return null
    if (props.users.length <= 0 && props.isEmpty) return null
    const users1 = new Set(props.users.map((user) => user.username))
    if (users1.size !== Object.keys(props.users).length) props.users = props.users.slice(1)
    let users = []
    if (props.users2 != null) {
      for (const user1 of props.users) {
        let isDuplicate = false
        for (const user2 of props.users2) {
          if (user1.username === user2.username) {
            isDuplicate = true
            break
          }
        }
        if (!isDuplicate) users.push(user1)
      }
    } else {
      users = props.users
    }
    return (
      <Style>
        <section className='search-container'>
          {(users.length > 0 && !props.isEmpty)
            ? users.map((user, index) => this.renderBadge(user, index))
            : this.renderEmptyList()}
        </section>
      </Style>
    )
  }
}

UserBadgeSearch.propTypes = {
  handleClick: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    username: PropTypes.string.isRequired,
    image: PropTypes.string
  })),
  users2: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    username: PropTypes.string.isRequired,
    image: PropTypes.string
  })),
  selectedOwner: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    username: PropTypes.string.isRequired,
    image: PropTypes.string
  }),
  language: PropTypes.string
}

export default UserBadgeSearch
